module.exports = __webpack_public_path__ + "img/market.cd959506.svg";